import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

const adminOnly = ({ gateKeeper, gate }) =>
    !!(
        gateKeeper.user?.is_super_admin ||
        gate.$store.getters['User/hasRole']('Admin') ||
        gate.$store.getters['User/hasRole']('Owner')
    );

export default [
    {
        path: '/feature-flags',
        name: 'feature-flags-index',
        component: () => import('@/pages/administration/FeatureFlagsIndex.vue'),
        meta: {
            title: 'Feature Flags',
            middleware: [GateKeeperMiddleware],
            ability: adminOnly,
            dataTablePage: true,
        },
        props: true,
    },
    {
        path: '/feature-flags/:feature',
        name: 'feature-flags-show',
        component: () => import('@/pages/administration/FeatureFlagShow.vue'),
        meta: {
            title: 'Feature Flag',
            middleware: [GateKeeperMiddleware],
            ability: adminOnly,
            dataTablePage: true,
        },
        props: route => ({
            feature: String(route.params.feature || '').toLowerCase(),
        }),
    },
];
